/**
 * range-scale.js -- Produktbilder maßstäblich (02.10.2026), only for product PHOTOS without a theme
 * cut-out (fit-<handle>.webp needs no script: it is already cropped to the vessel).
 * Uses the shared helper assets/photo-fit.js (window.CryonosPhotoFit.probe, owner: section-bauer
 * Produktseite; included, never changed here). For every img[data-scale-probe] the visible area of the
 * cut-out photo is measured once; the image then gets
 *   --fit-k    = 1 / visible height share  (the CSS multiplies the image height with it, so the VISIBLE
 *                vessel gets the height the row asks for)
 *   --fit-drop = transparent foot in % of the image height (the CSS moves the image down by it, so the
 *                visible foot stands on the base line)
 * and the class is-fit. Photos that are not cut-outs (opaque border) stay as they are.
 */
(function () {
  if (window.CryonosRangeScale) return;
  function run(root) {
    var api = window.CryonosPhotoFit;
    if (!api || !api.probe) return;
    var list = (root || document).querySelectorAll('img[data-scale-probe]:not([data-scale-done])');
    Array.prototype.forEach.call(list, function (img) {
      img.setAttribute('data-scale-done', '');
      api.probe(img.getAttribute('data-scale-probe')).then(function (bb) {
        if (!bb || !bb.cut) return;
        var vis = bb.b - bb.t;
        if (!(vis > 0.2)) return;
        img.style.setProperty('--fit-k', (1 / vis).toFixed(4));
        img.style.setProperty('--fit-drop', ((1 - bb.b) * 100).toFixed(2) + '%');
        img.classList.add('is-fit');
      });
    });
  }
  window.CryonosRangeScale = { run: run };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
